var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6842 5.82843L16.4053 2.10527H11.5789V0H20V8.42107H17.8947V3.59369L14.1716 7.31685C15.3862 8.90898 15.9503 10.9032 15.7498 12.8956C15.5494 14.8881 14.5992 16.7299 13.0918 18.0481C11.5843 19.3664 9.6323 20.0625 7.6309 19.9956C5.6295 19.9287 3.72832 19.1037 2.31232 17.6877C0.896328 16.2717 0.0713419 14.3705 0.00441457 12.3691C-0.0625128 10.3677 0.633621 8.41565 1.95186 6.90822C3.27009 5.4008 5.11191 4.45064 7.10437 4.25016C9.09683 4.04968 11.091 4.61385 12.6831 5.82843H12.6842ZM7.89472 17.8948C9.43018 17.8948 10.9028 17.2848 11.9885 16.1991C13.0742 15.1133 13.6842 13.6408 13.6842 12.1053C13.6842 10.5698 13.0742 9.09724 11.9885 8.0115C10.9028 6.92576 9.43018 6.3158 7.89472 6.3158C6.35925 6.3158 4.88667 6.92576 3.80093 8.0115C2.71519 9.09724 2.10523 10.5698 2.10523 12.1053C2.10523 13.6408 2.71519 15.1133 3.80093 16.1991C4.88667 17.2848 6.35925 17.8948 7.89472 17.8948Z",
    fill: "url(#paint0_linear_10080_4297)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10080_4297",
    x1: -1.4,
    y1: 22.9,
    x2: 22.3,
    y2: -1.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E827D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleIcon);
export default __webpack_public_path__ + "static/media/male_icon.3832ef89fa1ca17470c2ba828ea432d0.svg";
export { ForwardRef as ReactComponent };